import IconNode, { IconNodeProps } from '../IconNode'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

interface DiagramProps extends IconNodeProps {
  label?: string
  color?: string
}

export default function DiagramNode({ label, color, ...props }: DiagramProps) {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        color: color,
        zIndex: 1,
        maxWidth: 40
      }}>
      <IconNode size={24} {...props} />
      <Typography
        variant="caption"
        sx={{
          textAlign: 'center',
          minHeight: '1rem',
          maxWidth: 90,
          display: 'inline-block',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          marginTop: 0.5
        }}>
        {label}
      </Typography>
    </Stack>
  )
}
